<template>
  <div>
    <div class="mb-12">
      <div class="page-title mb-2">แบบฟอร์มคำร้องขอใช้พื้นที่

        <span>
          <Button v-if="currentStep == 2 || currentStep == 3" theme="4" min-width="120px"
            :disabled="isLoading" @onClick="autoField(currentStep)">
            autoField - step {{ currentStep }}
          </Button>
        </span>
      </div>

      <StatusStep :current-step="currentStep" :steps="documentSteps" @onClick="jumpStep"></StatusStep>
    </div>
    <!--  Form switcher  -->
    <div>
      <FisrtForm :masterData="masterData" :form-data="firstForm" v-if="currentStep == 1"></FisrtForm>
      <SecondForm :masterData="masterData" :form-data="secondForm" v-if="currentStep == 2"></SecondForm>
      <ThirdForm :masterData="masterData" :form-data="thirdForm" v-if="currentStep == 3"></ThirdForm>
      <FourthForm :masterData="masterData" :form-data="fourthForm" v-if="currentStep == 4"></FourthForm>
      <preview v-if="currentStep == 5"></preview>
    </div>

    <!-- Action buttons -->
    <div class="d-flex justify-space-between">
      <Button theme="2" @onClick="cancelled">ยกเลิก</Button>
      <div class="flex-center">
        <div v-if="currentStep == 1"></div>
        <div v-else>
          <Button theme="3" min-width="120px" :masterData="masterData" @onClick="backForm" :disabled="isLoading">&lt;
            ย้อนกลับ</Button>
        </div>

        <Button theme="4" min-width="120px" :masterData="masterData" :disabled="isLoading"
          @onClick="saveDraft(true)">บันทึกฉบับร่าง</Button>
        <Button v-if="currentStep == 5" :theme="validate('one') &&
          validate('two_one') &&
          validate('two_two') &&
          validate('two_three') &&
          validate('two_five') &&
          validate('two_six') &&
          validate('two_seven') &&
          validate('two_eight') &&
          validate('two_nine') &&
          validate('two_ten') &&
          validate('two_eleven') &&
          validate('two_twelve') &&
          validate('three_one') &&
          validate('three_two') &&
          validate('three_three') &&
          validate('three_four')
          ? '1'
          : '2'
          " min-width="120px" @onClick="submitForm" :disabled="validate('one') &&
            validate('two_one') &&
            validate('two_two') &&
            validate('two_three') &&
            validate('two_five') &&
            validate('two_six') &&
            validate('two_seven') &&
            validate('two_eight') &&
            validate('two_nine') &&
            validate('two_ten') &&
            validate('two_eleven') &&
            validate('two_twelve') &&
            validate('three_one') &&
            validate('three_two') &&
            validate('three_three') &&
            validate('three_four')
            ? false
            : true
            ">ยื่นแบบฟอร์ม</Button>
        <Button v-else theme="3" min-width="120px" :disabled="isLoading" :masterData="masterData"
          @onClick="nextForm">ถัดไป</Button>
      </div>
    </div>
  </div>
</template>

<script>
import StatusStep from "@/components/StatusStep";
import Button from "@/components/input/Button";
import FisrtForm from "./FisrtForm.vue";
import SecondForm from "./SecondForm.vue";
import ThirdForm from "./ThirdForm.vue";
import FourthForm from "./FourthForm.vue";
import preview from "./spaceRequestsPreview.vue";
import { eventBus, validateEmail } from "@/plugins/global-funcs";
import { mapState } from "vuex";

export default {
  name: "RequestForm",
  components: {
    StatusStep,
    Button,
    FisrtForm,
    SecondForm,
    ThirdForm,
    FourthForm,
    preview,
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.General.isLoading,
    }),
  },
  data() {
    return {
      isSubmitted: false,
      currentStep: 1,
      documentSteps: [
        {
          no: 1,
          name: "ข้อมูลประเภทพื้นที่",
        },
        {
          no: 2,
          name: "ข้อมูลโครงการ",
        },
        {
          no: 3,
          name: "แผนงาน",
        },
        {
          no: 4,
          name: "เอกสารแนบ",
        },
      ],
      validateForm: {},
      form2_5: [],
      firstForm: {},
      secondForm: {},
      thirdForm: {},
      fourthForm: {},
      draftId: null,
      masterData: {},
      userId: null,
    };
  },
  watch: {
    currentStep(newValue, oldValue) {
      console.info("currentStep: ", newValue, oldValue);
      if (newValue < oldValue) {
        this.retrieveForms();
      }
      if (newValue == 5) {
        this.retrieveForms();
      }
    },
  },
  created() {
    this.getUser();
    if (this.$route.params.id) {
      this.retrieveForms();
      this.createForm();
    } else {
      this.createForm();
    }

    eventBus.$on("firstFormSend", (form) => {
      this.firstForm = form;
      console.info("1 data: ", this.firstForm);
    });

    eventBus.$on("secondFormSend", (form) => {
      this.secondForm = form;
      console.info("2 data: ", this.secondForm);
    });

    eventBus.$on("thirdFormSend", (form) => {
      this.thirdForm = form;
      console.info("3 data: ", this.thirdForm);
    });

    eventBus.$on("fourthFormSend", (form) => {
      this.fourthForm = form;
      console.info("fourthForm data: ", this.fourthForm);
    });
  },
  methods: {
    validate(section) {
      let isCorrect = true;
      switch (section) {
        case "one":
          if (!this.validateForm?.user_type) {
            isCorrect = false;
          }
          return isCorrect;

        // case "two"
        case "two_one":
          if (
            !this.validateForm?.area_form_2?.company_name_th ||
            !this.validateForm?.area_form_2?.company_name_eng ||
            !this.validateForm?.area_form_2?.headquarters_address ||
            !this.validateForm?.area_form_2?.headquarters_postal_code ||
            !this.validateForm?.area_form_2?.headquarters_phone ||
            !this.validateForm?.area_form_2?.headquarters_email ||
            !this.validateForm?.area_form_2?.headquarters_website
          ) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_two":
          if (
            !this.validateForm?.area_form_2?.contact_name ||
            !this.validateForm?.area_form_2?.contact_position ||
            !this.validateForm?.area_form_2?.contact_email ||
            !this.validateForm?.area_form_2?.contact_phone ||
            !this.validateForm?.area_form_2?.contact_address
          ) {
            isCorrect = false;
          }

          return isCorrect;

        case "two_three":
          if (
            !this.validateForm?.area_form_2?.registration_number ||
            !this.validateForm?.area_form_2?.registration_date ||
            !this.validateForm?.area_form_2?.registration_capital ||
            !this.validateForm?.area_form_2?.business_size?.name ||
            this.validateForm?.area_form_2?.area_form_2_3?.length == 0
          ) {
            isCorrect = false;
          }
          if (this.validateForm?.area_form_2?.area_form_2_3?.length > 0) {
            this.validateForm?.area_form_2?.area_form_2_3.forEach((item) => {
              if (
                item.name == null ||
                item.name == "" ||
                item.position === null ||
                item.position == "" ||
                item.mobile_phone === null ||
                item.mobile_phone == "" ||
                item.email === null ||
                item.email == ""
              ) {
                isCorrect = false;
              }
            });
          }

          return isCorrect;
        // case "two_four":
        //   if (
        //     !this.validateForm?.area_form_2?.headquarters_joint_name ||
        //     !this.validateForm?.area_form_2?.headquarters_joint_nationality ||
        //     !this.validateForm?.area_form_2?.headquarters_joint_country ||
        //     !this.validateForm?.area_form_2?.headquarters_joint_capital ||
        //     !this.validateForm?.area_form_2?.headquarters_joint_website
        //   ) {
        //     isCorrect = false;
        //   }

        //   return isCorrect;
        case "two_five":
          if (
            !this.validateForm?.area_form_2?.industry_food &&
            !this.validateForm?.area_form_2?.industry_ict &&
            !this.validateForm?.area_form_2?.industry_science &&
            !this.validateForm?.area_form_2?.industry_materials &&
            !this.validateForm?.area_form_2?.industry_electronics &&
            !this.validateForm?.area_form_2?.industry_medical &&
            !this.validateForm?.area_form_2?.industry_auto &&
            !this.validateForm?.area_form_2?.industry_others
          ) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_six":
          if (!this.validateForm?.area_form_2?.reason_choose) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_seven":
          if (!this.validateForm?.area_form_2?.area_type?.name) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_eight":
          if (this.validateForm?.area_form_2?.area_form_2_8?.length == 0) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_nine":
          if (
            !this.validateForm?.area_form_2?.space_requirement_type ||
            this.validateForm?.area_form_2?.area_form_2_9?.length == 0
          ) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_ten":
          if (!this.validateForm?.area_form_2?.product_service_eco) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_eleven":
          if (
            !this.validateForm?.area_form_2?.space_ratio_lab &&
            !this.validateForm?.area_form_2?.space_ratio_office
          ) {
            isCorrect = false;
          }
          if (
            this.validateForm?.area_form_2?.space_ratio_lab &&
            !this.validateForm?.area_form_2?.space_ratio_lab_percent
          ) {
            isCorrect = false;
          }
          if (
            this.validateForm?.area_form_2?.space_ratio_office &&
            !this.validateForm?.area_form_2?.space_ratio_office_percent
          ) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_twelve":
          if (!this.validateForm?.area_form_2?.type_of_area_usage) {
            isCorrect = false;
          }
          if (
            this.validateForm?.area_form_2?.type_of_area_usage ===
            "จัดตั้งศูนย์วิจัยและพัฒนา (Research & Development Center)"
          ) {
            if (
              !this.validateForm?.area_form_2?.type_of_area_usage_th ||
              !this.validateForm?.area_form_2?.type_of_area_usage_eng
            ) {
              isCorrect = false;
            }
          }
          if (this.validateForm?.area_form_2?.type_of_area_usage === "อื่นๆ") {
            if (!this.validateForm?.area_form_2?.type_of_area_usage_other) {
              isCorrect = false;
            }
          }
          return isCorrect;

        // case "three"
        case "three_one":
          if (this.validateForm?.area_form_3?.spider_chart_3?.length == 0) {
            isCorrect = false;
          }
          return isCorrect;
        case "three_two":
          if (this.validateForm?.area_form_3?.area_form_3_2?.length == 0) {
            isCorrect = false;
          }
          return isCorrect;
        case "three_three":
          if (!this.validateForm?.area_form_3?.estimated_date) {
            isCorrect = false;
          }
          return isCorrect;
        case "three_four":
          if (
            !this.validateForm?.area_form_3?.appendix_info &&
            !this.validateForm?.area_form_3?.appendix_doc_cert &&
            !this.validateForm?.area_form_3?.appendix_doc_id_card_company &&
            !this.validateForm?.area_form_3?.appendix_doc_witness &&
            !this.validateForm?.area_form_3?.appendix_doc_postal &&
            !this.validateForm?.area_form_3?.appendix_doc_contact
          ) {
            isCorrect = false;
          }
          if (this.validateForm?.area_form_3?.appendix_doc_postal) {
            if (
              !this.validateForm?.area_form_3?.postal_name ||
              !this.validateForm?.area_form_3?.postal_position ||
              !this.validateForm?.area_form_3?.postal_mobile_phone ||
              !this.validateForm?.area_form_3?.postal_email ||
              !this.validateForm?.area_form_3?.postal_address
            ) {
              isCorrect = false;
            }
          }
          if (this.validateForm?.area_form_3?.appendix_doc_contact) {
            if (
              !this.validateForm?.area_form_3?.contact_name ||
              !this.validateForm?.area_form_3?.contact_position ||
              !this.validateForm?.area_form_3?.contact_mobile_phone ||
              !this.validateForm?.area_form_3?.contact_email ||
              !this.validateForm?.area_form_3?.contact_address
            ) {
              isCorrect = false;
            }
          }
          return isCorrect;
        default:
          return isCorrect;
      }
    },
    submitForm() {
      if (
        this.validate("one") &&
        this.validate("two_one") &&
        this.validate("two_two") &&
        this.validate("two_three") &&
        this.validate("two_five") &&
        this.validate("two_six") &&
        this.validate("two_seven") &&
        this.validate("two_eight") &&
        this.validate("two_nine") &&
        this.validate("two_ten") &&
        this.validate("two_eleven") &&
        this.validate("two_twelve") &&
        this.validate("three_one") &&
        this.validate("three_two") &&
        this.validate("three_three") &&
        this.validate("three_four")
      ) {
        this.$apiFire("Request/updateSpaceRequestsForm", {
          id: this.$route.params.id,
          status: "Submitted",
        })
          .then((res) => {
            if (res) {
              this.$router.push({ name: "spaceRequestsList" });
            }
          })
          .catch((error) => {
            this.$store.commit("General/setModal", {
              title: "Error",
              text: error.message,
              theme: "error",
              showCancel: false,
              buttonText: "OK",
            });
            return;
          });
      }
    },
    async getUser() {
      let user = await this.$apiFire("Auth/getUser");
      console.info("user: ", user);
      this.userId = user.id;
    },
    jumpStep(step) {
      if (step == this.currentStep) return;
      if (this.isLoading) {
        this.$store.commit("General/setModal", {
          title: "Wait a moment.",
          text: "Preparing data please wait...",
          theme: "warning",
          showCancel: false,
          buttonText: "OK",
        });
        return;
      }
      if (this.$route.params.id || this.draftId) {
        this.currentStep = parseInt(step);
        this.$vuetify.goTo("#app");
        this.doNotSubmit = false;
      } else {
        this.$store.commit("General/setModal", {
          title: "Complete this step first!",
          text: "Complete the first step then you can jump",
          theme: "error",
          showCancel: false,
          buttonText: "OK",
        });
      }
    },
    backForm() {
      if (this.currentStep <= 1) return;
      const res = this.saveDraft();
      if (res) {
        this.currentStep -= 1;
        // ถ้ามี draftId แล้ว ให้ push route ไปที่ edit
        if (this.draftId) {
          return this.$router.push(
            "/space-requests-management/space-requests-form/" + this.draftId
          );
        }
        this.$vuetify.goTo("#app");
      }
    },
    async nextForm() {
      if (this.currentStep >= this.documentSteps.length) {
        const res = await this.saveDraft();
        if (res) {
          this.currentStep = 5;
          // return this.$router.push({
          //   name: "spaceRequestsPreview",
          //   params: { id: this.draftId },
          // });
        }
      } else {
        const res2 = await this.saveDraft();
        if (res2) {
          this.currentStep += 1;
          // router replace เติม query ไปด้วย
          if (this.draftId) {
            return this.$router.push(
              "/space-requests-management/space-requests-form/" + this.draftId
            );
          }
          this.$vuetify.goTo("#app");
        }
      }
    },
    async saveDraft(goToList = false) {
      this.requestForm(this.currentStep);

      // validate formGeneral
      // if (this.currentStep == 1) {
      //   if (!this.firstForm.area_form_1_type_id) {
      //     this.$store.commit("General/setModal", {
      //       title: "ข้อมูลไม่ถูกต้อง",
      //       text: "กรุณากรอกข้อมูลให้ถูกต้อง",
      //       theme: "error",
      //       showCancel: false,
      //       buttonText: "OK",
      //     });
      //     return false;
      //   }
      // }
      // if (this.currentStep == 2) {
      //   if (this.secondForm?.area_form_2_3?.length > 0) {
      //     let hasInvalidValue = false;

      //     this.secondForm.area_form_2_3.forEach((item) => {
      //       if (
      //         (item.name == null || item.name == "") &&
      //         (item.position === null || item.position == "") &&
      //         (item.mobile_phone === null || item.mobile_phone == "") &&
      //         (item.email === null || item.email == "")
      //       ) {
      //         hasInvalidValue = true;
      //       }
      //     });

      //     if (hasInvalidValue) {
      //       this.$store.commit("General/setModal", {
      //         title: "ข้อมูลไม่ครบถ้วน",
      //         text: "กรุณากรอกข้อมูลให้ถูกต้อง",
      //         theme: "error",
      //         showCancel: false,
      //         buttonText: "OK",
      //       });
      //       return false;
      //     }
      //   }
      // }

      //get today date Y-m-d
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();
      today = yyyy + "-" + mm + "-" + dd;

      let payload = {
        ...this.firstForm,
        ...(Object.keys(this.secondForm).length > 0 && {
          area_form_2: { ...this.secondForm },
        }),
        ...(Object.keys(this.thirdForm).length > 0 && {
          area_form_3: { ...this.thirdForm },
        }),
        attachments: this.fourthForm ? this.fourthForm : [],
        status: this.isSubmitted ? "Submitted" : "Draft", // require field
        year: this.masterData.fiscal_year,
        date: today,
      };

      if (payload.attachments?.length > 0) {
        let uploadPromises = payload.attachments.map((attachment, index) => {
          if (attachment instanceof File) {
            return this.uploadFile(attachment).then((result) => {
              console.log("file ", index, "is uploaded");
              return result;
            });
          } else {
            return Promise.resolve(attachment);
          }
        });
        payload.attachments = await Promise.all(uploadPromises);
      }

      // Add the ID to the payload if it exists
      if (this.draftId) {
        payload.id = this.draftId;
      }

      console.info("payload: ", payload);
      let res = null;
      // Check if the form has an ID
      if (payload.id) {
        try {
          console.info("update draft");
          res = await this.updateDraft(payload);
        } catch (error) {
          this.$store.commit("General/setModal", {
            title: "Error",
            text: error.message,
            theme: "error",
            showCancel: false,
            buttonText: "OK",
          });
          return;
        }
      } else {
        try {
          console.info("save draft");
          res = await this.$apiFire("Request/saveSpaceRequestsForm", payload);
          // Update the form's ID after saving
          this.draftId = res.id;
        } catch (error) {
          this.$store.commit("General/setModal", {
            title: "Error",
            text: error.message,
            theme: "error",
            showCancel: false,
            buttonText: "OK",
          });
          return;
        }
      }
      if (goToList) {
        this.$router.push({ name: "spaceRequestsList" });
      }
      // eslint-disable-next-line no-prototype-builtins
      return typeof res === "object" && res.hasOwnProperty("id");
    },

    async uploadFile(file) {
      try {
        let formData = new FormData();
        formData.append("files[]", file);
        let payload = {
          files: formData,
        };
        let res = await this.$apiFire("Attachment/uploadFile", formData);
        if (res.length > 0) {
          return res[0];
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    },

    async updateDraft(payload) {
      let res = await this.$apiFire("Request/updateSpaceRequestsForm", payload);
      console.info(res);
      return res;
    },
    requestForm(formStep) {
      switch (formStep) {
        case 1:
          eventBus.$emit("firstForm");
          break;

        case 2:
          eventBus.$emit("secondForm");
          break;

        case 3:
          eventBus.$emit("thirdForm");
          break;
        case 4:
          eventBus.$emit("fourthForm");
          break;
      }
    },
    async createForm() {
      let res = await this.$apiFire("Request/createSpaceRequestsForm");
      console.info(res);
      if (res) {
        this.masterData = res;
      }
    },
    retrieveForms() {
      // Retrieve the form data
      this.$apiFire("Request/getSpaceRequestsListById", {
        id: this.draftId ?? this.$route.params.id,
      }).then((res) => {
        console.info("getSpaceRequestsListById: ", res);
        if (res) {
          this.draftId = res.id;
          this.isSubmitted = res.status == "Submitted";
          //form1
          this.firstForm.area_form_1_type_id = res.area_form_1_type_id;
          this.secondForm = {
            ...res.area_form_2,
          };
          this.thirdForm = {
            ...res.area_form_3,
          };
          this.fourthForm = res.attachments || [];
          this.validateForm = res;
        }
      });
    },
    cancelled() {
      if (!this.$route.query.fromAll) {
        this.$router.push({ name: "spaceRequestsList" });
      } else {
        this.$router.push({ name: "spaceRequestsAll" });
      }
    },
    autoField(step) {
      if (step === 2) {
        const mapData2 = {
          company_name_th: "ตัวอย่างบริษัท",
          company_name_eng: "ตัวอย่างบริษัท",
          headquarters_address: "ตัวอย่างสำนักงานใหญ่",
          headquarters_postal_code: "10100",
          headquarters_phone: "0888888888",
          headquarters_fac: "0888888888",
          headquarters_email: "example@example.com",
          headquarters_website: "https://www.example.com",

          // ส่วนที่ 2: ข้อมูลผู้ติดต่อประสานงาน
          contact_name: "ตัวอย่าง ตัวอย่าง",
          contact_position: "ตัวอย่างตำแหน่ง",
          contact_address: "1/1 ตัวอย่างที่อยู่",
          contact_fac: "0888888888",
          contact_phone: "0888888888",
          contact_email: "example@example.com",

          // ส่วนที่ 3: การจดทะเบียนบริษัท
          registration_number: "1212312121",
          registration_date: "2025-01-01",
          registration_capital: "1000000",
          business_size_id: 1,

          // ส่วนที่ 3.4: กรรมการผู้มีอำนาจลงนาม
          area_form_2_3: [{ name: "ตัวอย่าง", position: "ตัวอย่าง", phone: "0888888888", mobile_phone: "0888888888", email: "example@example.com" }],

          // ส่วนที่ 4: บริษัทแม่/บริษัทร่วมทุน
          headquarters_joint_name: "ตัวอย่างชื่อบริษัท",
          headquarters_joint_nationality: "ตัวอย่างสัญชาติ",
          headquarters_joint_country: "ตัวอย่างประเทศที่ตั้ง",
          headquarters_joint_capital: "ตัวอย่างทุนจดทะเบียน",
          headquarters_joint_website: "https://www.example.com",

          // ส่วนที่ 5: ประเภทอุตสาหกรรม
          industry_food: true,
          industry_ict: true,
          industry_science: true,
          industry_materials: false,
          industry_electronics: false,
          industry_medical: false,
          industry_auto: false,
          industry_others: false,
          industry_others_specify: false,

          // ส่วนที่ 6: เหตุผล
          reason_choose: "ตัวอย่างเหตุผลในการเลือกอยู่อาคารอำนวยการอุทยานวิทยาศาสตร์",

          // ส่วนที่ 7: ประเภทผู้ใช้บริการ
          area_type_id: 1,

          // ส่วนที่ 9: ความต้องการใช้พื้นที่
          space_requirement_type: "สำนักงานเพื่อการวิจัยและพัฒนาสำหรับผู้ประกอบการขนาดเล็ก กลาง ใหญ่ (R&D Office for SML Enterprises)",
          space_requirement_startup: "ตัวอย่างStartup office type",

          // ส่วนที่ 10: การสนับสนุน/บริการ
          product_service_eco: "ตัวอย่างการสนับสนุนหรือให้บริการแก่ผู้ใช้งานอาคารฯ รายอื่นๆ",
          area_form_2_8: [{ "room_type": "ประเภทห้อง", "no": 1, "room_size": "100" }],
          area_form_2_9: [ { "position": "ตัวอย่างตำแหน่ง", "no": 1 } ], 
          // ส่วนที่ 11: สัดส่วนพื้นที่
          space_ratio_lab: "ตัวอย่างอัตราการใช้พื้นที่ห้อง Lab (Laboratory)",
          space_ratio_lab_percent: "ตัวอย่างเปอร์เซ็นต์ Lab",
          space_ratio_office: "ตัวอย่างอัตราการใช้พื้นที่สำนักงาน (Office)",
          space_ratio_office_percent: "ตัวอย่างเปอร์เซ็นต์ Office",

          // ส่วนที่ 12: การบริหารงานของบริษัท/หน่วยงาน
          type_of_area_usage: "จัดตั้งศูนย์วิจัยและพัฒนา (Research & Development Center)",
          type_of_area_usage_th: "ตัวอย่างชื่อศูนย์ฯ ภาษาไทย",
          type_of_area_usage_eng: "ตัวอย่างชื่อศูนย์ฯ ภาษาอังกฤษ",
        };
        this.secondForm = { ...this.secondForm, ...mapData2 };
        this.$nextTick(() => {
          this.$emit("secondFormSend", this.secondForm);
        });
      } else if (step == 3) {
        const mapStep3 = {
          estimated_date: "2025-06-01",
          appendix_info: 1, 
          appendix_doc_cert: true, 
          spider_chart_3: [
            {
              isNew: true,
              source_topical: ["สำนักงบประมาณ"],
              year: "1", 
              name: "โครงการ1", 
              plan: "ตัวอย่างแผนการดำเนินงาน ", 
              budget: "100", 
              duration: "5"
            }
          ], 
          area_form_3_1: [],
          area_form_3_2: [
            { isNew: true, 
              education_level: "ปริญญาเอก (Ph.D.)", 
              year_1: 1, 
              total_employee: 6, 
              year_2: 2, 
              year_3: 3 
            }
          ]
        }
      this.thirdForm = { ...this.thirdForm, ...mapStep3 };
      this.$nextTick(() => {
        this.$emit("thirdFormSend", this.thirdForm);
      });
      }
  },
},
beforeDestroy() {
  eventBus.$off("firstFormSend");
  eventBus.$off("secondFormSend");
  eventBus.$off("thirdFormSend");
  eventBus.$off("fourthFormSend");
},


};
</script>

<style scoped></style>
